import { CardLoader } from 'components/organisms'
import PaginationBar from 'components/organisms/pagination-bar/pagination-bar'
import withLoader from 'hocs/with-loader/with-loader'
import { Table } from 'reactstrap'
import PropTypes from 'prop-types'
import ProductDiscountTableRow from 'domains/product-discount/tables/product-discount-table-row'

const proptypes = {
  tableProps        : PropTypes.object,
  displayedProducts : PropTypes.array,
  pagination        : PropTypes.object,
  isLoading         : PropTypes.bool,
  onClickRemove     : PropTypes.func,
  onPageChange      : PropTypes.func
}

const defaultProps = {
  tableProps        : {},
  displayedProducts : [],
  pagination        : {},
  isLoading         : true,
  onClickRemove     : () => {},
  onPageChange      : () => { }
}

const ProductDiscountTable = ({
  tableProps,
  displayedProducts,
  pagination,
  isLoading,
  onClickRemove,
  onPageChange
}) => {
  const totalColumns = 7
  const TableContent = () => (
    <Table { ...tableProps }>
      <thead>
        <tr>
          <th scope="col">{ 'sku' }</th>
          <th scope="col">{ 'status' }</th>
          <th scope="col">{ 'stock status' }</th>
          <th scope="col">{ 'selling price' }</th>
          <th scope="col">{ 'new selling price' }</th>
          <th scope='col'>{ 'disabled reason' }</th>
          <th scope="col">{ 'action' }</th>
        </tr>
      </thead>
      <tbody>
        {
          displayedProducts.map((product) => (
            <ProductDiscountTableRow
              key={ `ProductDiscountTableRow-${product.id}` }
              product={ product }
              handleClickRemove={ () => onClickRemove(product) }
            />
          ))
        }

        {
          displayedProducts.length === 0 &&
          <tr>
            <td
              colSpan={ totalColumns }
              className='bg-warning text-white'
            >
              <i className='fas fa-info-circle mr-3' />
              { 'No Products to show' }
            </td>
          </tr>
        }
      </tbody>
    </Table>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <div className='d-flex justify-content-between mt-3'>
        <PaginationBar
          onClickPage={ onPageChange }
          pagination={ pagination }
        />
      </div>
    </>
  )

}

ProductDiscountTable.propTypes    = proptypes
ProductDiscountTable.defaultProps = defaultProps

export default ProductDiscountTable
